export const headers = [
  { field: "nombre", headerName: "Nombre", width: 150 },
  { field: "sucursal", headerName: "Sucursal", width: 130 },
  { field: "radio_km", headerName: "Radio", width: 80 },
  { field: "monto_minimo", headerName: "Monto Mín.", width: 110 },
  { field: "costo_envio", headerName: "Envío", width: 100 },
  { field: "envio_gratis_desde", headerName: "Gratis Desde", width: 110 },
  { field: "acepta_entregas", headerName: "Estado", width: 100 },
];

export default headers;